// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var MatchingStatusUpdaterLocalQuery_graphql = require("../../../__generated__/MatchingStatusUpdaterLocalQuery_graphql.bs.js");

var convertVariables = MatchingStatusUpdaterLocalQuery_graphql.Internal.convertVariables;

var convertResponse = MatchingStatusUpdaterLocalQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = MatchingStatusUpdaterLocalQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, MatchingStatusUpdaterLocalQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, MatchingStatusUpdaterLocalQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(MatchingStatusUpdaterLocalQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(MatchingStatusUpdaterLocalQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(MatchingStatusUpdaterLocalQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(MatchingStatusUpdaterLocalQuery_graphql.node, convertVariables);

var commitLocalPayload = RescriptRelay_Query.commitLocalPayload(MatchingStatusUpdaterLocalQuery_graphql.node, convertVariables, convertWrapRawResponse);

var LocalMatchingStatusQuery_matchingStatusV5_decode = MatchingStatusUpdaterLocalQuery_graphql.Utils.matchingStatusV5_decode;

var LocalMatchingStatusQuery_matchingStatusV5_fromString = MatchingStatusUpdaterLocalQuery_graphql.Utils.matchingStatusV5_fromString;

var LocalMatchingStatusQuery = {
  matchingStatusV5_decode: LocalMatchingStatusQuery_matchingStatusV5_decode,
  matchingStatusV5_fromString: LocalMatchingStatusQuery_matchingStatusV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain,
  commitLocalPayload: commitLocalPayload
};

function update(environment, nodeId, __typename, matchingStatus) {
  commitLocalPayload(environment, {
        nodeId: nodeId
      }, {
        node: {
          __typename: __typename,
          __isMatchable: __typename,
          matchingStatus: matchingStatus,
          nodeId: nodeId
        }
      });
}

exports.LocalMatchingStatusQuery = LocalMatchingStatusQuery;
exports.update = update;
/* use Not a pure module */
